import { useEffect, useState } from 'react';

/**
 * Debounce a value by `delayMs`. Returns the last value that has been
 * stable for the full delay. Typical use: debounce user input before
 * firing a server-side query so a fast typist doesn't issue a request per
 * keystroke.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);
  return debounced;
}
